(function() {
    'use strict';

    angular
        .module('verificadocumentoApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
